import React, { useMemo, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import { api } from "../../auth/api";
import { useAuth } from "../../auth/AuthContext";
import "./Members.css";

function MembersVerify() {
  const [params] = useSearchParams();
  const token = useMemo(() => (params.get("token") || "").trim(), [params]);
  const navigate = useNavigate();
  const { setMember } = useAuth();
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const inFlight = useRef(false);

  const complete = async (remember) => {
    if (!token) {
      setError("Missing sign-in token.");
      return;
    }
    if (inFlight.current) return;
    inFlight.current = true;
    setSubmitting(true);
    setError("");
    try {
      const data = await api.verify(token, remember);
      setMember({
        ...data.member,
        pending_access_count: data.member.is_admin ? 0 : undefined,
      });
      try {
        const me = await api.me();
        setMember(me);
      } catch {
        /* cookie may still be enough for later navigation */
      }
      navigate("/members", { replace: true });
    } catch (err) {
      setError(err.message || "Could not complete sign-in");
      inFlight.current = false;
      setSubmitting(false);
    }
  };

  return (
    <>
      <Header />
      <main className="members-page">
        <div className="verify-panel">
          <h1>Stay signed in?</h1>
          <p className="help-text">
            Would you like us to remember you on this device for 180 days using
            a secure cookie? Choose no to stay signed in only for this browser
            session.
          </p>
          {!token ? (
            <div className="message message-error">
              This sign-in link is missing a token. Request a new link from the
              members page.
            </div>
          ) : null}
          {error ? <div className="message message-error">{error}</div> : null}
          <div className="members-actions">
            <button
              className="btn"
              type="button"
              disabled={!token || submitting}
              onClick={() => complete(true)}
            >
              Yes, remember me for 180 days
            </button>
            <button
              className="btn btn-outline"
              type="button"
              disabled={!token || submitting}
              onClick={() => complete(false)}
            >
              No, just this session
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default MembersVerify;
